module.exports = __webpack_public_path__ + "img/carrier-logo.48c4e641.svg";